import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=50090d36&lang=pug"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=50090d36&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports